<template>
  <div>
    <div>
      <b-card
        title="Card Title"
        img-src="https://picsum.photos/600/300/?image=25"
        img-alt="Image"
        img-top
        tag="article"
        style="max-width: 20rem"
        class="mb-2"
      >
        <b-card-text>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </b-card-text>

        <b-button href="#" variant="primary">Go somewhere</b-button>
      </b-card>
    </div>
    <checkout-form></checkout-form>

    <b-list-group>
      <b-list-group-item v-for="row in rows" v-bind:key="row.id">
        <orderrow
          v-if="showShoppingrows"
          :row="row"
          v-bind:key="row.article_id"
          :visible="row.visible"
        >
        </orderrow>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import axios from "axios";
import CheckoutForm from "./CheckoutForm";
import Orderrow from "./Orderrow";

export default {
  name: "ShoppingList",
  components: { Orderrow, CheckoutForm },
  data() {
    return {
      rows: [],
      showCheckout: false,
      showShoppingrows: true,
      selectionView: 3,
      oldselectionView: null,
      oldgroup: null,
      default_group: 0,
      searchText: "",
      show: false,
      super_total: 0,
      super_vat: 0
    };
  },
  mounted: function() {
    axios
      .get("https://eavedev.eu.ngrok.io/api/1/frontorder", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        console.log(response);
        if (response.status === 201) {
          this.rows = response.data.data.rows;
        }
      });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ShoppingList.vue